import { render, staticRenderFns } from "./Professional.vue?vue&type=template&id=27fd108a&scoped=true"
import script from "./Professional.vue?vue&type=script&lang=js"
export * from "./Professional.vue?vue&type=script&lang=js"
import style0 from "./Professional.vue?vue&type=style&index=0&id=27fd108a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27fd108a",
  null
  
)

export default component.exports